"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogoDark = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var LogoDark = exports.LogoDark = function LogoDark(props) {
  return _react2.default.createElement("svg", _extends({
    viewBox: "0 0 1200 385"
  }, props), _react2.default.createElement("path", {
    d: "M346.1 70.3h-116c-32.5 0-53.2 23.4-59.6 50.4-5 19.7-6.9 28.9-28 111.4v1.8L122 312.8s-5 23.4 25.2 5.5l56.4-34.4h92.1c33 0 53.2-23.4 59.6-50.9 0-.5 15.6-61.4 28.4-112.3 7.8-32.5-6.4-50.4-37.6-50.4z",
    fill: "#fb713f"
  }), _react2.default.createElement("path", {
    d: "M561.5 146.9h-9.1l-6.9 26.1-20.6 77H557c4.1-14.7 19.7-74.2 21.1-78.4 2.7-15.1-2.8-23.8-16.6-24.7zm386.9 0h-9.1l-6.9 26.1-20.6 77h32.1c4.1-14.7 20.2-74.2 21.1-78.4 3.1-15.1-2.9-23.8-16.6-24.7zm-289.7 0h-59.1l-38 141.2h33.9l10.1-38H634c15.6 0 25.7-11.5 28.9-24.3s10.1-38 14.2-54.1-3.3-24.8-18.4-24.8zm-14.2 28.9c-.5 2.3-11 41.7-11.9 44-.5 1.8-2.3 3.2-4.1 3.2h-15.6l14.2-50.4h14.7c3.2-.5 3.2.9 2.7 3.2zm148-28.9l-20.2 72.9c-.5 1.8-1.8 2.7-3.7 3.2H760c-1.4 0-2.3-.9-2.3-2.3v-.9l20.2-72.9h-31.6l-20.2 72.9c-.5 1.8-1.8 2.7-3.7 3.2h-8.7c-1.4 0-2.3-.9-2.3-2.3v-.9l20.2-72.9H700c-7.3 26.6-21.5 77.9-22 80.2-2.3 9.6 6 22.9 17 22.9h77c11 0 26.1-8.7 29.3-20.6 1.4-5.5 15.6-56.4 22.5-82.5h-31.3zm253 0h-59.1l-38.5 141.2h33.9l10.1-38h28c15.6 0 25.7-11.5 28.9-24.3 3.2-12.8 10.1-38 14.2-54.1s-2.3-24.8-17.5-24.8zm-14.2 28.4c-.5 2.3-11 41.7-11.9 44-.5 1.8-2.3 3.2-4.1 3.2h-16.1l14.2-50.4h14.7c3.7 0 3.7 1.4 3.2 3.2zM526.7 179c4.1-3.2 6.4-8.2 6.9-13.3.9-9.2-6-17.4-15.6-18.3h-66l-6.9 26.6H491l-58.7 45.8c-3.2 3.2-5.5 7.3-5.5 11.9-.9 9.6 6 17.9 15.6 18.8h66l7.3-27.5h-44.9l55.9-44zm371.7-32.1h-27.5l11.9-44.5h-31.2l-17 62.3-22.8 85.3h33.9l21.1-77.9h14.7c3.2 0 3.2 1.4 2.7 3.7 0 .9-10.1 38.5-19.7 74.2h31.6c9.2-34.4 18.8-70.6 20.6-78.4 3.7-16-3.2-24.7-18.3-24.7zm184.7 2.3c.5 0 .5-.5.5-.9v-.9c-.5-.5-.5-.5-.9-.5h-9.6c-.5 0-.9 0-1.4.5-.5 0-.5.5-.5.9v.9c.5.5.5.5.9.5h3.2l-3.7 11v1.4c0 .5.5.5.9.5.5 0 .9 0 1.4-.5s.9-.9.9-1.4l3.7-11h3.2c.5-.1.9-.1 1.4-.5zm16.5-1.9c-.5-.5-.9-.5-1.4-.5h-2.3c-.5 0-.5.5-.9.5-.5.5-.5.9-.9 1.4l-5 8.2.5-8.2v-1.4c0-.5 0-.5-.5-.5h-2.3c-.5 0-.9 0-1.4.5s-.9.9-.9 1.4l-4.1 11.9v1.4c0 .5.5.5.9.5.5 0 .9 0 1.4-.5s.5-.9.9-1.4l3.2-10.5-.9 9.6v1.8c0 .5 0 .5.5.5s.5.5.9 0c.5 0 .9 0 1.4-.5.5 0 .5-.5.9-.9 0-.5.5-.9.9-1.4l5.5-9.6-3.2 10.5v1.4c0 .5.5.5.9.5.5 0 .9 0 1.4-.5s.5-.9.9-1.4l4.1-11.9c0 .5 0-.4-.5-.9z",
    fill: "#3e444d"
  }), _react2.default.createElement("path", {
    d: "M339.7 129c-.5 7.8-3.7 14.7-9.6 19.2l-80.7 63.2h65.1L304 250.9h-93c-13.7 0-24.7-10.5-25.2-24.3v-2.7c0-6.9 2.7-12.8 7.8-17.4l84.8-66h-66.5l10.1-38h92.6c13.3-.5 24.7 10.1 25.2 23.8-.1.9-.1 1.8-.1 2.7z",
    fill: "#fff"
  }));
};